import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortComponent } from './sort.component';
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [SortComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot()
  ],
  exports: [SortComponent]
})
export class SortModule { }
